import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Check, Star } from 'lucide-react';
import { pricingPackages } from '../mock';

const Pricing = () => {
  const handleBooking = (packageName) => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-orange-600 font-semibold text-sm uppercase tracking-wide">
            Tarifs
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-4">
            Des forfaits adaptés à vos besoins
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choisissez la formule qui correspond à votre projet musical
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {pricingPackages.map((pkg) => (
            <Card
              key={pkg.id}
              className={`relative transition-all duration-300 ${
                pkg.popular
                  ? 'border-2 border-orange-600 shadow-2xl scale-105'
                  : 'border-2 border-gray-200 hover:border-orange-400 hover:shadow-xl'
              }`}
            >
              {pkg.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <div className="bg-orange-600 text-white px-4 py-1 rounded-full text-sm font-semibold flex items-center">
                    <Star className="w-4 h-4 mr-1 fill-current" />
                    Plus populaire
                  </div>
                </div>
              )}

              <CardHeader className="text-center pb-8 pt-8">
                <CardTitle className="text-2xl font-bold text-gray-900 mb-2">
                  {pkg.name}
                </CardTitle>
                <p className="text-gray-600 text-sm mb-4">{pkg.description}</p>
                <div className="flex items-baseline justify-center">
                  <span className="text-5xl font-bold text-gray-900">{pkg.price}€</span>
                  <span className="text-gray-600 ml-2">/ {pkg.duration}</span>
                </div>
              </CardHeader>

              <CardContent>
                <ul className="space-y-4 mb-8">
                  {pkg.features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <Check className="w-5 h-5 text-orange-600 mr-3 mt-0.5 flex-shrink-0" />
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Button
                  className={`w-full ${
                    pkg.popular
                      ? 'bg-orange-600 hover:bg-orange-700 text-white'
                      : 'bg-white hover:bg-orange-50 text-orange-600 border-2 border-orange-600'
                  }`}
                  onClick={() => handleBooking(pkg.name)}
                >
                  Choisir {pkg.name}
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-4">
            Tous nos forfaits incluent l'ingénieur du son et l'utilisation de notre équipement professionnel
          </p>
          <p className="text-sm text-gray-500">
            Forfaits personnalisés disponibles sur demande • Paiement sécurisé • Devis gratuit
          </p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
